import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';

const siteMap = document.getElementById('SiteMap');
if(siteMap)
{
	// define the item component
	Vue.component('sitemap-item', {
		template: '#item-template',
		props: {
			model: Object
		},
		mounted: function() {
			const self = this;
		},
		computed: {
			isFolder: function () {
				const self = this;
				return self.model.children &&
					self.model.children.length
			},
		},
		methods: {
			toggleOpen: function () {
				const self = this;
				if (self.isFolder) {
					self.model.open = !self.model.open;
				}
			},
			toggleChecked: function () {
				const self = this;

				self.model.checked = !self.model.checked;
			},
		}
	});

	const vueComponentName = new Vue({
		el: '#SiteMap',
		data: {
			model: [],
			isLoading: true,
		},
		mounted: function() {
			const self = this;
	
			request().get('/SiteMapPage/Get/?lang=' + currentLang()).then(function(response) {
				self.model = response;
				self.isLoading = false;
			});
		},
		methods: {
				
		}
	});
}



// WEBPACK FOOTER //
// ../components/site-map/site-map.js